import React from 'react';

interface IzakayaNoticeProps {
  lang: 'ja' | 'en';
}

export const IzakayaNotice: React.FC<IzakayaNoticeProps> = ({ lang }) => {
  const content = {
    ja: {
      title: '重要なお知らせ',
      notices: [
        {
          icon: 'ri-restaurant-line',
          title: '酒類の提供について',
          description: '酒類の提供は提携飲食店が行います。当サービスは酒類販売業ではありません。'
        },
        {
          icon: 'ri-car-line',
          title: '運送業ではありません',
          description: '当サービスは運送業ではありません。移動は徒歩または公共交通機関を利用します。'
        },
        {
          icon: 'ri-wallet-line',
          title: '飲食代について',
          description: '飲食代は料金に含まれておりません。各店舗で直接お支払いください。'
        },
        {
          icon: 'ri-time-line',
          title: '所要時間',
          description: '基本は3時間のプランです。延長をご希望の場合は事前にご相談ください。'
        }
      ]
    },
    en: {
      title: 'Important Notice',
      notices: [
        {
          icon: 'ri-restaurant-line',
          title: 'Alcohol Service',
          description: 'Alcoholic beverages are served by our partner restaurants. We are not a liquor retailer.'
        },
        {
          icon: 'ri-car-line',
          title: 'Not a Transportation Service',
          description: 'This is not a transportation service. We travel on foot or by public transit.'
        },
        {
          icon: 'ri-wallet-line',
          title: 'Food & Drink Costs',
          description: 'Food and drink costs are not included in the price. Please pay directly at each venue.'
        },
        {
          icon: 'ri-time-line',
          title: 'Duration',
          description: 'The standard plan is 3 hours. Please inquire in advance if you wish to extend.'
        }
      ]
    }
  };

  const t = content[lang];

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-100 rounded-full mb-6">
            <i className="ri-alert-line text-red-600 text-xl"></i>
            <span className="text-red-700 font-semibold">{lang === 'ja' ? '必ずお読みください' : 'Please Read'}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            {t.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {t.notices.map((notice, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-amber-300 transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                  <i className={`${notice.icon} text-2xl text-amber-600`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {notice.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {notice.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};